import { Button, Modal } from "antd";

const ConfirmModal = ({
  open,
  handleCancel,
  handleConfirm,
  title,
  description,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  ...rest
}) => {
  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      maskClosable={false}
      closable={true}
      width={700}
      footer={
        <div
          style={{
            display: "flex",
            gap: "8px",
            padding: "20px",
          }}
        >
          <Button
            onClick={handleCancel}
            style={{
              flex: 1,
              background: "#FFFFFF",
              color: "#6B6B6B",
              border: "1px solid #EDEDED",
              paddingTop: "24px",
              paddingBottom: "24px",
              fontSize: "18px",
              borderRadius: "0px",
            }}
          >
            {cancelButtonText}
          </Button>

          <Button
            onClick={handleConfirm}
            style={{
              flex: 1,
              background: "#052659",
              color: "#FFFFFF",
              border: "none",
              paddingTop: "24px",
              paddingBottom: "24px",
              fontSize: "18px",
              borderRadius: "0px",
            }}
          >
            {confirmButtonText}
          </Button>
        </div>
      }
      title={
        <div className="d-flex flex-column align-items-center text-center">
          <div className="mt-4 px-3 text-start">
            {/* Use DeleteModal styles for text */}
            <h3
              style={{
                fontFamily: "Gilroy",
                fontWeight: 700,
                fontSize: "22px",
                lineHeight: "28px",
                letterSpacing: "0px",
                color: "#000000",
                marginBottom: "8px",
              }}
            >
              {title}
            </h3>
            <p
              style={{
                fontFamily: "Gilroy",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "20px",
                letterSpacing: "0px",
                color: "#666666",
                margin: 0,
              }}
            >
              {description}
            </p>
          </div>
        </div>
      }
      {...rest}
    />
  );
};

export default ConfirmModal;
